import 'flowbite-react'

export default function Navbar() {
    return (
        <nav className="justify-center z-10 w-full mt-4 hidden md:flex" id="navbar-default">
            <ul className="text-xl mt-12 md:mt-0 p-4 md:p-0 rounded-lg md:rounded-none text-black md:text-white bg-white md:bg-opacity-0 flex justify-between flex-col md:flex-row items-center w-full z-10 border-white border-b-2 text-white max-w-3xl">
                <li className="py-3">
                    <a href="/" className="hover:text-primary">Inicio</a>
                </li>
                <li className="py-3">
                    <a href="/about-us" className="hover:text-primary">Sobre nosotros</a>
                </li>
                <li className="py-3">
                    <a href="/research" className="hover:text-primary">Investigación</a>
                </li>
                <li className="py-3">
                    <a href="/contact" className="hover:text-primary">Contacto</a>
                </li>
            </ul>
        </nav>
    );
}